import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Dropdown from '../common/form/dropdown';
import ArrowButton from '../common/button-arrow';

import './my-incentives.css';

class MyIncentives extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: this.props.data,
            outlets: [],
            loading: false,
            active: null
        };
    }

    onChange = val => {
        this.setState({
            active: val.value
        })
    }

    componentDidMount = () => {
        let outlets = [];

        this.setState({
            loading: true,
        }, () => {
            this.props.data.map((outlet, key) => {
                if (key == 0) {
                    this.setState({
                        active: this.props.defaultStore ? this.props.defaultStore.toString() : outlet.id
                    })
                };

                outlets.push({
                    value: outlet.id,
                    label: outlet.attributes.name
                })

                if (key == this.props.data.length - 1) {
                    this.setState({
                        outlets: outlets,
                        loading: false
                    })
                }
            })
        })
    }

    render() {
        return (
                !this.state.loading &&
                    <div className="my-incentives">
                        <Dropdown data={this.state.outlets} onChange={this.onChange} value={this.state.active}/>
                        {this.state.data.map(outlet => (
                            outlet.id == this.state.active &&
                                outlet.attributes.incentives.map(incentive => (
                                    <div key={incentive.id} className="incentive-container">
                                        <div className="incentive-container-flex-row">
                                            <h4>{incentive.name}</h4>
                                            <div className="incentive-brand-images-container">
                                                {incentive.products.map((product, i) => (
                                                    i < 3 ? (
                                                        <div key={product.id} className="incentive-brand-image-container">
                                                            <img src={product.image} alt={product.name} />
                                                        </div>
                                                    ) : null
                                                ))}
                                                {incentive.products.length > 3 ? (
                                                    <div className="incentive-brands-more">
                                                        +{incentive.products.length - 3}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <Link to={'/latest-news'}>
                                            <ArrowButton arrow={false} color='grey' submit={false}>CLICK FOR MORE INFO</ArrowButton>
                                        </Link>
                                    </div>
                                ))
                        ))}
                    </div>
        )
    }
}

const mapStateToProps = (state) => {
  return {
    defaultStore: state.viewConfig.profile.attributes["default-outlet-id"]
  };
};

export default connect(mapStateToProps)(MyIncentives);



// WEBPACK FOOTER //
// ./src/components/my-incentives/my-incentives.jsx